/* eslint-disable @typescript-eslint/no-explicit-any */
import { ReactNode, useEffect, useRef } from 'react'
import { IoCloseOutline } from 'react-icons/io5'
import { animated, useTransition } from 'react-spring'

import { useClickOutside } from '../hooks/useClickOutside.tsx'

interface ModalWrapperProps {
  children: ReactNode
  showModal: boolean
  onClose: () => void
  withHandleKeyDown?: boolean
}

export const ModalWrapper = ({
  children,
  onClose,
  showModal,
  withHandleKeyDown = true,
}: ModalWrapperProps) => {
  const modalRef = useRef(null)

  useClickOutside(modalRef, onClose)

  useEffect(() => {
    document.body.style.overflow = 'hidden'

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        if (withHandleKeyDown) onClose()
      }
    }

    window.addEventListener('keydown', handleKeyDown)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [])

  const modalTransitions = useTransition(showModal, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 300 },
  })

  const backdropTransitions = useTransition(showModal, {
    from: { opacity: 0 },
    enter: { opacity: 0.46 },
    leave: { opacity: 0 },
    config: { duration: 300 },
  })

  return (
    <>
      {backdropTransitions((styles: any, item: any) =>
        item ? (
          <animated.div style={styles} className="modal-backdrop" />
        ) : null,
      )}

      {modalTransitions((styles: any, item: any) =>
        item ? (
          <animated.div
            ref={modalRef}
            className="modal relative"
            style={styles}
          >
            <IoCloseOutline
              className="absolute right-4 top-4 cursor-pointer text-xl hover:scale-125"
              onClick={onClose}
            />
            {children}
          </animated.div>
        ) : null,
      )}
    </>
  )
}
